var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400391 16.7927C0.400391 16.4574 0.642906 16.1855 0.942057 16.1855H12.8587C13.1579 16.1855 13.4004 16.4574 13.4004 16.7927C13.4004 17.128 13.1579 17.3998 12.8587 17.3998H0.942057C0.642906 17.3998 0.400391 17.128 0.400391 16.7927Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02799 0.400391C2.32715 0.400391 2.56966 0.672221 2.56966 1.00753V7.6861C2.56966 10.3686 4.50975 12.5432 6.90299 12.5432C9.29624 12.5432 11.2363 10.3686 11.2363 7.6861V1.00753C11.2363 0.672221 11.4788 0.400391 11.778 0.400391C12.0772 0.400391 12.3197 0.672221 12.3197 1.00753V7.6861C12.3197 11.0392 9.89451 13.7575 6.90299 13.7575C3.91148 13.7575 1.48633 11.0392 1.48633 7.6861V1.00753C1.48633 0.672221 1.72884 0.400391 2.02799 0.400391Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underline-icon.b324e8124bb185c5361dc39142d964ba.svg";
export { ForwardRef as ReactComponent };